module.exports = __webpack_public_path__ + "img/codiver.9c9841c2.png";